import '/src/common/js/global';
import '/src/pages/home/views/services/services';
import '/src/pages/home/views/faq/faq';
